<template>
  <div class="searched-text-layout" :class="{'pa-3': hasEnteredValues}">
    <div v-for="param in requestParams" :key="param.key" class="searched-params">
      <template v-if="param.value.length > 0">
        <div class="searched-type">
          {{ param.key }}:
        </div>
        <div>
          <div v-for="(inputValue, index) in param.value" :key="index" class="searched-values">
            {{ param.value[index] }}
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { SEARCHED_TEXT_PARAMS } from '../searchPropertyConst'
import { hasNonEmptyKey } from '../../../utils/generalUtils'

export default {
  computed: {
    ...mapState('common', ['searchObject', 'searchTextParams']),

    hasEnteredValues() {
      return hasNonEmptyKey(this.searchTextParams)
    }
  },

  watch: {
    searchTextParams: {
      handler: function(newValue, oldValue) {
        this.setRequestParam(newValue)
      },
      deep: true
    }
  },

  created() {
    this.setRequestParam(this.searchTextParams)
  },

  methods: {
    setRequestParam(object) {
      const tempObject = { ...object }
      delete tempObject.StreetNumber
      delete tempObject.Keywords
      if (!tempObject.hasOwnProperty('MLSNumber')) {
        tempObject.MLSNumber = []
      }
      this.requestParams = []
      Object.values(tempObject).forEach((value, index) => {
        this.requestParams.push({ key: SEARCHED_TEXT_PARAMS[index], value })
      })
    }
  }
}
</script>

<style lang="sass" scoped>
.searched-text-layout
  display: flex
  flex-flow: row
  background-color: $hwayzec

.searched-params
  display: flex
  margin-right: 4rem
  font-size: 1.3rem
  width: 100%
  .searched-type
    margin-right: 2rem
  .searched-values
    text-align: left
    color: $hwayzKellyGreen
</style>
